export default {
  mutations: {
    SET_PAYMENT_MODES_LIST: 'SET_PAYMENT_MODES_LIST',
  },
  getters: {
    GET_PAYMENT_MODES_LIST: 'GET_PAYMENT_MODES_LIST',
  },
  actions: {
    PAYMENT_MODES_LIST: 'PAYMENT_MODES_LIST',
  },
};
